import React from "react";
import styles from "./Card.module.scss";

interface CardProps {
  icon?: string; // icon є необов'язковим
  title: string;
  description?: string; // description також необов'язковим
}

const Card: React.FC<CardProps> = ({ icon, title, description }) => {
  // Умовно визначаємо клас для title, якщо немає опису і іконки
  const titleClass =
    icon || description ? styles.cardTitle : styles.cardTitleWithNoContent;

  return (
    <div className={styles.card}>
      {/* Якщо icon передано, то виводимо картинку */}
      {icon && <img src={icon} alt={title} className={styles.cardIcon} />}
      <h3
        className={titleClass}
        dangerouslySetInnerHTML={{
          __html: title, // Використовуємо dangerouslySetInnerHTML для обробки HTML
        }}
      />
      {/* Якщо description передано, виводимо його */}
      {description && <p className={styles.cardDescription}>{description}</p>}
    </div>
  );
};

export default Card;
